import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Button, Input, Select, Alert } from 'antd';
import '../../assets/css/contactus.css';
import { validateEmail } from '../../assets/js/validators';
import { apiGetPage, apiAddInfo, apiGetCustom } from '../../request/api'
const { TextArea } = Input;

interface contactInfo {
    contactUs: string;
    ourEmail: string;
    name: string;
    surName: string;
    companyName: string;
    contactEmail: string;
    tallUs: string;
    chooseType: string;
    buttonTxt: string;
    emailError: string;
    shouldIn: string;
    remindUs: string,

}

interface companyType {
    value: string;
    label: string;
}

const HomePart4: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);

    // 状态管理每个输入字段
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(''); // 新增状态管理文本区域
    const [selectedOption, setSelectedOption] = useState(null); // 允许为空
    const [companyTypeList, setCompanyTypeList] = useState<companyType[]>([])
    const DEFAULT_BG = '#e5e5ee'; // 原背景色
    const FILLED_BG = '#ffffff';  // 填写后的背景色
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    // 错误状态
    const [companyNameError, setCompanyNameError] = useState<string | null>(null);
    const [emailError, setEmailError] = useState<string | null>(null);
    const [messageError, setMessageError] = useState<string | null>(null); // 新增文本区域错误状态
    const [contactInfo, setConteactInfo] = useState<contactInfo>({
        contactUs: "",
        ourEmail: "",
        name: "",
        surName: "",
        companyName: "",
        contactEmail: "",
        tallUs: "",
        chooseType: "",
        buttonTxt: "",
        emailError: "",
        shouldIn: "",
        remindUs: "",
    });

    const handleChange = (
        setter: React.Dispatch<React.SetStateAction<string>>,
        errorSetter: React.Dispatch<React.SetStateAction<string | null>>,
        value: string,
        isEmail?: boolean
    ) => {
        setter(value);
        // 移除了邮箱的实时验证，只保留非邮箱字段的清除错误逻辑
        if (!isEmail && value.trim() !== '') {
            errorSetter(null);
        }
    };

    useEffect(() => {
        apiGetCustom({
            pageId: '887EB9E23DF64D4AB167F8DD317692C5',
            languageCode,
            size: 100
        }).then((res) => {
            const data = res.data.data;

            const newContactInfo: Partial<contactInfo> = {};
            let companyTypesRaw = '';

            data.forEach((item: any) => {
                switch (item.code) {
                    case 'contactTitle':
                        newContactInfo.contactUs = item.value;
                        break;
                    case 'serviceEmail':
                        newContactInfo.ourEmail = item.value;
                        break;
                    case 'inputName':
                        newContactInfo.name = item.value;
                        break;
                    case 'inputSex':
                        newContactInfo.surName = item.value;
                        break;
                    case 'inputCompanyName':
                        newContactInfo.companyName = item.value;
                        break;
                    case 'inputEmail':
                        newContactInfo.contactEmail = item.value;
                        break;
                    case 'inputUrNeed':
                        newContactInfo.tallUs = item.value;
                        break;
                    case 'plaseChoose':
                        newContactInfo.chooseType = item.value;
                        break;
                    case 'remindUs':
                        newContactInfo.shouldIn = item.value;
                        break;
                    case 'companyType':
                        companyTypesRaw = item.value;
                        break;
                    case 'remindUs':
                        newContactInfo.remindUs = item.value;
                        break;
                    case 'pageTitle': // 忽略不需要的字段
                    case 'pageURL':
                    default:
                        break;
                }
            });
            console.log(contactInfo)

            // 更新 contactInfo
            setConteactInfo(prev => ({
                ...prev,
                ...newContactInfo,
                emailError: '请输入有效的邮箱', // 你可以根据实际情况设定默认提示
            }));

            // 处理公司类型为 Select options
            if (companyTypesRaw) {
                const options = companyTypesRaw.split(',').map((type: string) => ({
                    value: type.trim(),
                    label: type.trim(),
                }));
                setCompanyTypeList(options);
            }
        });
    }, []);


    const sendContent = () => {
        let hasError = false;

        if (!validateEmail(email)) {
            setEmailError(contactInfo.emailError);
            hasError = true;
        } else {
            setEmailError(null);
        }

        // 保持其他字段的验证逻辑不变
        if (message.trim() === '') {
            setMessageError(contactInfo.shouldIn);
            hasError = true;
        } else {
            setMessageError(null);
        }

        if (!hasError) {
            apiAddInfo({
                tid: 'CBE9CE9A61454A369910195588871788',
                name: firstName,
                surName: lastName,
                contactEmail: email,
                companyName: companyName,
                companyType: selectedOption,
                tallUs: message,
            }).then(res => {
                // console.log(res)
            })
        }
    };

    return (
        <div className="home-part4">
            <div className='home-part4_header1'>{contactInfo.contactUs}</div>
            <div className='home-part4_header2'>{contactInfo.ourEmail}</div>
            <div className='home-part4_input_box'>
                <div className='home-part4_input_box_left'>
                    <Input
                        placeholder={contactInfo.name}
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        style={{
                            backgroundColor: firstName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    <Input
                        placeholder={contactInfo.surName}
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        style={{
                            backgroundColor: lastName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    <Input
                        placeholder={contactInfo.companyName}
                        value={companyName}
                        onChange={(e) => handleChange(setCompanyName, setCompanyNameError, e.target.value)}
                        status={companyNameError ? 'error' : ''}
                        style={{
                            backgroundColor: companyName.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />

                    {companyNameError && <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>{companyNameError}</div>}

                    <Select
                        value={selectedOption}
                        style={{ width: 528, fontSize: '18px' }}
                        onChange={setSelectedOption}
                        allowClear
                        className={selectedOption ? 'selected-state' : ''}
                        placeholder={contactInfo.chooseType}
                        options={companyTypeList.length > 0 ? companyTypeList : [{ value: '', label: 'Loading...' }]}
                    />

                    <Input
                        placeholder={contactInfo.contactEmail}
                        value={email}
                        onChange={(e) => handleChange(setEmail, setEmailError, e.target.value, true)}
                        status={emailError ? 'error' : ''}
                        style={{
                            backgroundColor: email.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                    />
                    {emailError && <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>{emailError}</div>}
                </div>
                <div className='home-part4_input_box_right'>
                    <TextArea
                        className='testarea-tent'
                        rows={4}
                        placeholder={contactInfo.tallUs}
                        value={message}
                        style={{
                            backgroundColor: message.trim() ? FILLED_BG : DEFAULT_BG,
                            transition: 'background-color 0.3s ease'
                        }}
                        onChange={(e) => {
                            setMessage(e.target.value);
                            if (e.target.value.trim() === '') {
                                setMessageError(contactInfo.shouldIn);
                            } else {
                                setMessageError(null);
                            }
                        }}
                        status={messageError ? 'error' : ''}
                    />
                    {messageError && <div style={{ color: '#e60d0d', marginTop: '3px', fontSize: '12px', marginLeft: '144px' }}>{messageError}</div>}
                </div>
            </div>
            <div className='part4-button'>
                <button className='contactus-button' style={{ background: themeColor, boxShadow: "0 2px 4px 0 " + themeColor }} onClick={sendContent}>{contactInfo.shouldIn}</button>
            </div>
        </div>
    );
};

export default HomePart4;